// lazy-loading of youtube and image content for production page
var productionLazyLoad = {

    initialize: function() {
        var movies = document.querySelectorAll('.c-composition-moviedetail');

        if (movies && movies.length > 0) {
            console.log('init lazy-loading...');

            var movie = null;
            for (var i = 0; i < movies.length ; i++) {
                movie = movies[i];
                video = movie.querySelector('.c-video');
                if (video) {
                    video.innerHTML = productionLazyLoad.decodeHtmlentities(video.dataset.youtube);
                }
            }

        }
    },

    decodeHtmlentities: function (htmlencoded) {
        var txt = document.createElement('textarea');
        txt.innerHTML = htmlencoded;
        return txt.value;
    }

};

// attach productionLazyLoad to window.onload
if(window.attachEvent) {
    window.attachEvent('onload', productionLazyLoad.initialize);
} else {
    if(window.onload) {
        var curronload = window.onload;
        var newonload = function(e) {
            curronload(e);
            productionLazyLoad.initialize(e);
        };
        window.onload = newonload;
    } else {
        window.onload = productionLazyLoad.initialize;
    }
}
